export enum HistoryPurposes {
  TASK_AWARD = "TASK_AWARD",
  DAILY_CHECKIN = "DAILY_CHECKIN",
  REFERRAL_AWARD = "REFERRAL_AWARD",
  CHALLENGE_AWARD = "CHALLENGE_AWARD",
  CHALLENGE_PARTICIPANT_FEE = "CHALLENGE_PARTICIPANT_FEE",
  CHALLENGE_OPPORTUNITY_FEE = "CHALLENGE_OPPORTUNITY_FEE",
  EXTERNAL_APP = "EXTERNAL_APP",
  P2P_TRANSFER = "P2P_TRANSFER",
  VOUCHER_REDEEM = "VOUCHER_REDEEM",
}

// Populated by the backend only when purpose === P2P_TRANSFER. Lets us
// render counterparty / commission / cross-side transfer ID without a
// follow-up request from the detail sheet.
export interface P2PTransactionInfo {
  counterparty_username: string | null;
  counterparty_full_name: string | null;
  commission_uzs: string | null;
  transfer_id: string | null;
}

export interface Transaction {
  id: string;
  // 1 = income, -1 = outcome. Kept as `number` so income/outcome
  // comparisons inside already-narrowed branches stay valid.
  type: number;
  purpose: HistoryPurposes;
  amount: string;
  display_title: string;
  created_at: string;
  application: { name: string; logo: string } | null;
  p2p?: P2PTransactionInfo | null;
}
